import { render, staticRenderFns } from "./producth5.vue?vue&type=template&id=3fbd55b0&scoped=true&"
import script from "./producth5.vue?vue&type=script&lang=js&"
export * from "./producth5.vue?vue&type=script&lang=js&"
import style0 from "./producth5.vue?vue&type=style&index=0&id=3fbd55b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd55b0",
  null
  
)

export default component.exports